import React, { useState } from 'react';
import MultipleButton from './MultipleButton'; // Import the component
import Joystick from './Joystick';
import './App.css';
import './CustomButton.css';

function ControllerInfo({ lureBtnLabel, image }) {
    let infoBtnColour = '#474646';
    let btnPressColour = '#ba9771';
    const ProfileButtonSet = [
        {
            id: 'pbtn1', key: '1', label: 'Reveal', color: infoBtnColour, pressedColor: btnPressColour, position: { top: 0, left: 0 },
            description: 'To show where you are on the screen.', image: image, imgRadius: 170, isImageInfoMode: true
        },
        {
            id: 'pbtn2', key: '2', label: lureBtnLabel, color: infoBtnColour, pressedColor: btnPressColour, position: { top: 10, left: 75 },
            description: 'Drop to bait the fish or release it once you got it parasitic.', isInfoMode: true
        }
    ];
    const RightButtonSet = [
        {
            id: 'rbtn1', key: '1', label: 'Cancel', color: infoBtnColour, pressedColor: btnPressColour, position: { top: -20, left: '18%' },
            description: 'Quit the undergoing event, including "Dash", "Cover", "Join", "Date" and "Party".', isInfoMode: true
        },
        {
            id: 'rbtn2', key: '2', label: 'Dash', color: infoBtnColour, pressedColor: btnPressColour, position: { top: '10%', left: '50%' }, radiusSize: 110,
            description: 'Speed up the fish. It will bounce above the water sometimes if you are skillful.', isInfoMode: true
        },
        {
            id: 'rbtn3', key: '3', label: 'Cover', color: infoBtnColour, pressedColor: btnPressColour, position: { top: '30%', left: 0 },
            description: 'Get closer to the shelter, and it swims and hides inside itself. Press "Cancel" to release from the shelter.', isInfoMode: true
        },
        {
            id: 'rbtn4', key: '4', label: 'Join', color: infoBtnColour, pressedColor: btnPressColour, position: { top: '64%', left: '29%' },
            description: 'Two situations in which you can make this "Join" functional. First, someone is seeking someone to date... or someone is having a party.', isInfoMode: true
        },
    ];
    const EventButtonSet = [
        {
            id: 'ebtn1', key: '1', label: 'Date', color: infoBtnColour, pressedColor: btnPressColour, position: { top: 0, left: 0 },
            description: 'You can date with others, but you will need to wait for others to join to make this work. Hint: Press "Cancel" to end this event.', isInfoMode: true
        },
        {
            id: 'ebtn2', key: '2', label: 'Party', color: infoBtnColour, pressedColor: btnPressColour, position: { top: 0, left: 85 },
            description: 'You can be a host to have a party. Notice that there is only one party event in the whole scene.', isInfoMode: true
        },
    ];

    let outlineClassName = "custom-button circle outterline";
    const [buttonDetail, setButtonDetail] = useState(null);
    const ClickToShowInfo = (buttonDescription) => {
        if (!buttonDescription) {
            setButtonDetail(null); // Clear if button lacks needed data
            return;
        }
        setButtonDetail(<div>{buttonDescription}</div>);
    };

    let GamepadSetUIs =
        <div style={{ position: 'relative', top: 140 }}>
            <div style={{ position: 'absolute' }}>
                <Joystick
                    onMove={() => null}
                    onStop={() => null}
                    isInfoMode={true}
                    isDisabled={false}
                    onClick={ClickToShowInfo}
                />
                <div style={{ position: 'absolute', top: 160, left: -5 }}>
                    <MultipleButton buttonData={EventButtonSet} onClick={ClickToShowInfo} baseClasses={outlineClassName}>
                        {{ ebtn1: "", ebtn2: "" }}
                    </MultipleButton>
                </div>
            </div>
            <div style={{ position: 'absolute', right: 25, width: '180px', height: '180px' }}>
                <MultipleButton buttonData={RightButtonSet} onClick={ClickToShowInfo} baseClasses={outlineClassName}>
                    {{ rbtn1: "", rbtn2: "", rbtn3: "", rbtn4: "" }}
                </MultipleButton>
            </div>
            <div style={{ top: 250 }} className={"custom-button-label"}>{buttonDetail}</div>
        </div>


    return (<div>
        <div className="alignedUpperCenter" style={{ position: 'relative' }}>
            <div style={{ position: 'absolute' }}>
                <MultipleButton buttonData={ProfileButtonSet} onClick={ClickToShowInfo} baseClasses={outlineClassName}>
                    {{ pbtn1: "", pbtn2: "" }}
                </MultipleButton>
            </div>
        </div>
        {GamepadSetUIs}
    </div>);
};
export default ControllerInfo;